import { useState, useEffect, forwardRef } from 'react';
import Axios from 'axios';
import {
  Paper, TableBody, makeStyles, TableCell, TableRow, Button, IconButton, Modal, Card, CardHeader, Divider,
  CardContent, Grid, TextField, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@material-ui/core';
import Cookies from 'universal-cookie';
import AdminTable from '../Components/AdminTable';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Edit, Close, Cancel } from '@mui/icons-material';
import GroupIcon from '@mui/icons-material/Group';
import { useHistory } from 'react-router';
import "./TeamsAdmin.css"
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const TeamsAdmin = (props) => {
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [error, setErrorMessage] = useState('');
  const [success, setSuccessMessage] = useState('');
  const cookies = new Cookies();
  const userToken = cookies.get('tokenCTF');
  const history = useHistory();
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenError(false);
    setOpenSuccess(false);
  };
  const useStyles = makeStyles(theme => ({
    pageContentTeam: {
      marginTop: '15vh',
      marginLeft: '30vw',
      width: '60%',
      padding: theme.spacing(3),
      overflowX: 'auto',
      overflowY: 'hidden',
    },
    searchInput: {
      width: '75%'
    },
    modalTeam: {
      position: 'absolute',
      width: 500,
      backgroundColor: 'white',
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      //padding: '16px 32px 24px',
      padding: theme.spacing(2, 4, 3, 4),
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    createButton: {
      alignSelf: 'flex-end',
      marginLeft: 'auto',
    },
    buttonModified: {
      margin: theme.spacing(1),
    }

  }))
  const classes = useStyles();
  const [records, setRecords] = useState([])
  const [recordsMembers, setRecordsMembers] = useState([])
  const [change, setChange] = useState(false)
  const [modalTeamM, setModalTeamM] = useState(false);
  const [modalAddTeam, setModalAddTeam] = useState(false);
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [openRemoveDialogUser, setOpenRemoveDialogUser] = useState(false);
  const [removeTeamID, setRemoveTeamID] = useState(0);
  const [removeUserID, setRemoveUserID] = useState(0);
  const headCells = [
    { id: 'user', label: 'Equipo' },
    { id: 'points', label: 'Puntaje', disableSorting: true },
    { id: 'actions', label: 'Acciones', disableSorting: true },

  ]
  const headCellsMembers = [
    { id: 'id', label: 'ID' },
    { id: 'user', label: 'Usuario' },
    { id: 'type', label: 'Tipo', disableSorting: true },
    { id: 'points', label: 'Puntaje', disableSorting: true },
    { id: 'actions', label: 'Acciones', disableSorting: true },

  ]
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting
  } = AdminTable(records, headCells);
  const {
    TblContainer: TblContainer2,
    TblHead: TblHead2,
    TblPagination: TblPagination2,
    recordsAfterPagingAndSorting: recordsAfterPagingAndSorting2
  } = AdminTable(recordsMembers, headCellsMembers);

  const openCloseModal = () => {
    setModalTeamM(!modalTeamM);
  }
  const closeModal =()=>{
    setModalTeamM(false);
    setRecordsMembers([]);
  }
  const openCloseModalAdd = () => {
    setModalAddTeam(!modalAddTeam);
  }
  function handleOpenRemoveDialog(id) {
    setOpenRemoveDialog(true);
    setRemoveTeamID(id);
  };

  const handleCloseRemoveDialog = () => {
    setOpenRemoveDialog(false);
    setRemoveTeamID(0);
  };
  function handleOpenRemoveDialogUser(id) {
    setOpenRemoveDialogUser(true);
    setRemoveUserID(id);
  };

  const handleCloseRemoveDialogUser = () => {
    setOpenRemoveDialogUser(false);
    setRemoveUserID(0);
  };
  useEffect(() => {
    Axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/teamsAdmin/getTeamAdmin`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else if (response.data.noAdmin) {
        history.push('/user');
      }
      else {
        setRecords(response.data)
        setChange(false)
      }
    })
  }, [change])

  const deleteTeam = (id) => {
    Axios.delete(`https://${process.env.REACT_APP_BASE_URL}/api/teamsAdmin/deleteAllTeam/${id}`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (response.data.messageSuccess) {
          setSuccessMessage(response.data.messageSuccess)
          setChange(true)
          handleCloseRemoveDialog();
          setOpenSuccess(true)
        }
        else if (response.data.messageError) {
          setErrorMessage(response.data.messageError)
          setOpenError(true)
        }
        else {
          setErrorMessage('');
          setOpenError(false);
          setSuccessMessage('');
          setOpenSuccess(false);
        }
      }
    })

  }
  const showUsers = (id) => {
    Axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/teamsAdmin/getTeamMembersAdmin/${id}`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        setRecordsMembers(response.data)
      }
    })
    openCloseModal()
  }
  const deleteUser = (id) => {
    Axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/teamsAdmin/deleteTeamUser`, {
      action: 'leave',
      id: id,
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (response.data.messageSuccess) {
          setSuccessMessage(response.data.messageSuccess);
          openCloseModal();
          setChange(true);
          setOpenSuccess(true);
          handleCloseRemoveDialogUser();
        }
        else if (response.data.messageError) {
          setErrorMessage(response.data.messageError)
          setOpenError(true);
        }
        else {
          setErrorMessage('')
          setSuccessMessage('')
          setOpenSuccess(false);
          setOpenError(false);
        }
      }
    });
  };
  const onSubmit = () => {
    Axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/teamsAdmin/createTeam`, {
      name: name,
      password: password,
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (response.data.messageSuccess) {
          openCloseModalAdd();
          setChange(true);
          setSuccessMessage(response.data.messageSuccess);
          setOpenSuccess(true);
        }
        else if (response.data.messageError) {
          setErrorMessage(response.data.messageError);
          setOpenError(true);
        }
        else {
          setErrorMessage('');
          setSuccessMessage('');
          setOpenError(false);
          setOpenSuccess(false);
        }
      }
    });

  }
  return (
    <div className="teamAdmin">
      <Paper className="pageContentTeamAdmin">
        <div align="right">
          <Button className="createButton" onClick={() => openCloseModalAdd()} color='primary' variant='outlined'>Crear nuevo equipo</Button>
        </div>
        <TblContainer>
          <TblHead />
          <TableBody>
            {
              recordsAfterPagingAndSorting().map(item => (
                <TableRow key={item.team_id} >
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.score}</TableCell>
                  <TableCell>
                    <IconButton onClick={(e) => (showUsers(item.team_id))}>
                      <GroupIcon fontSize="small" color="primary" />
                    </IconButton>
                    <IconButton color="error" onClick={() => { handleOpenRemoveDialog(item.team_id) }}>
                      <Cancel fontSize="small" color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </TblContainer>
        <TblPagination />
      </Paper>
      <Modal open={modalTeamM} onClose={openCloseModal}>
        <div className="modalTeam">
          <Paper>
            <TblContainer2>
              <TblHead2 />
              <TableBody>
                {
                  recordsAfterPagingAndSorting2().map(item => (
                    <TableRow key={item.id} >
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.username}</TableCell>
                      <TableCell>{item.type}</TableCell>
                      <TableCell>{item.score}</TableCell>
                      <TableCell>
                        <IconButton color="secondary" onClick={(e) => { handleOpenRemoveDialogUser(item.id) }}>
                          <Cancel fontSize="small" color="error" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </TblContainer2>
            <TblPagination2 />
          </Paper>
          <div align="right" className="divMarginTop">
          <Button variant='outlined' color='secondary' onClick={closeModal} >Cerrar</Button>
          </div>
        </div>
      </Modal>
      <Modal open={modalAddTeam} onClose={openCloseModalAdd}>
        <Card className="team-config" >
          <CardHeader
            title="Crear nuevo equipo"
          />
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={6}
                xs={12}
              >


                <TextField
                  fullWidth
                  label="Nombre de Equipo"
                  name="name"
                  required
                  variant="outlined"
                  onChange={(e) => {
                    setName(e.target.value)
                  }}
                />

              </Grid>

              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  label="Password del Equipo"
                  name="password"
                  type="password"
                  required
                  variant="outlined"
                  onChange={(e) => {
                    setPassword(e.target.value)
                  }}
                />
              </Grid>


            </Grid>
          </CardContent>
          <Divider />
          <Box
          className="boxDisplayJustify"
          >
            <Button type='submit' variant="outlined" color="primary" className="buttonModified"
              onClick={onSubmit}>
              Crear
            </Button>
            <Button type='submit' variant="outlined" color="secondary" className="buttonModified"
              onClick={openCloseModalAdd}>
              Cancelar
            </Button>
          </Box>
        </Card>
      </Modal>
      <Dialog
        open={openRemoveDialog}
        onClose={handleCloseRemoveDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Eliminar Equipo"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Está seguro que desea eliminar el equipo?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => { deleteTeam(removeTeamID) }}>Sí</Button>
          <Button onClick={handleCloseRemoveDialog} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openRemoveDialogUser}
        onClose={handleCloseRemoveDialogUser}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Quitar usuario"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Está seguro que desea quitar al usuario del equipo?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => { deleteUser(removeUserID) }}>Sí</Button>
          <Button onClick={handleCloseRemoveDialogUser} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" className="alertWdithTop">
          {error}
        </Alert>
      </Snackbar>
      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" className="alertWdithTop">
          {success}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default TeamsAdmin;